var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaximize4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.125C17.1583 8.125 16.875 7.84167 16.875 7.5V3.125H12.5C12.1583 3.125 11.875 2.84167 11.875 2.5C11.875 2.15833 12.1583 1.875 12.5 1.875H17.5C17.8417 1.875 18.125 2.15833 18.125 2.5V7.5C18.125 7.84167 17.8417 8.125 17.5 8.125Z",
    fill: "#0851B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.125H2.5C2.15833 18.125 1.875 17.8417 1.875 17.5V12.5C1.875 12.1583 2.15833 11.875 2.5 11.875C2.84167 11.875 3.125 12.1583 3.125 12.5V16.875H7.5C7.84167 16.875 8.125 17.1583 8.125 17.5C8.125 17.8417 7.84167 18.125 7.5 18.125Z",
    fill: "#0851B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.37511C11.0917 9.37511 10.9333 9.31678 10.8083 9.19178C10.5667 8.95011 10.5667 8.55011 10.8083 8.30845L17.0583 2.05845C17.3 1.81678 17.7 1.81678 17.9417 2.05845C18.1833 2.30011 18.1833 2.70011 17.9417 2.94178L11.6917 9.19178C11.5667 9.31678 11.4083 9.37511 11.25 9.37511Z",
    fill: "#0851B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49999 18.1251C2.34166 18.1251 2.18333 18.0668 2.05833 17.9418C1.81666 17.7001 1.81666 17.3001 2.05833 17.0584L8.30833 10.8084C8.54999 10.5668 8.94999 10.5668 9.19166 10.8084C9.43333 11.0501 9.43333 11.4501 9.19166 11.6918L2.94166 17.9418C2.81666 18.0668 2.65833 18.1251 2.49999 18.1251Z",
    fill: "#0851B5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize4);
export default __webpack_public_path__ + "static/media/maximize-4.d3ff58be2989db01c2ef705b463d5934.svg";
export { ForwardRef as ReactComponent };